import assessmentRepository from '@/repositories/answerer/assessment.repository'

class AssessmentService {
  async callSaveAsessment (params) {
    const data = await assessmentRepository.callSaveAsessment(params);
    return data || [];
  }
  async callAssessmentInfo (userType, language) {
    const data = await assessmentRepository.callAssessmentInfo(userType, language);
    return data || [];
  }
  async callAssessmentList () {
    const data = await assessmentRepository.callAssessmentList();
    return data || [];
  }
  async callDeleteAssessment (updateAssessmentDtoStatus) {
    const data = await assessmentRepository.callDeleteAssessment(updateAssessmentDtoStatus);
    return data || [];
  }
  async callConfirmAssessment (updateAssessmentDtoStatus) {
    const data = await assessmentRepository.callConfirmAssessment(updateAssessmentDtoStatus);
    return data || [];
  }
  async callPreviewAssessment (previewAssessmentId) {
    const data = await assessmentRepository.callPreviewAssessment(previewAssessmentId);
    return data || [];
  }
  async callFindAssessmentResult () {
    const data = await assessmentRepository.callFindAssessmentResult();
    return data || [];
  }
  async findAssessmentResultByConditions (params) {
    const data = await assessmentRepository.findAssessmentResultByConditions(params);
    return data || [];
  }
  async callResendEmail (params) {
    const data = await assessmentRepository.callResendEmail(params);
    return data || [];
  }
  async callFindUserInfo (params) {
    const data = await assessmentRepository.callFindUserInfo(params);
    return data || [];
  }
  async assessmentInfo (assessmentId, language) {
    const data = await assessmentRepository.assessmentInfo(assessmentId, language);
    return data || [];
  }
  async findSearchConditions () {
    const data = await assessmentRepository.findSearchConditions();
    return data || [];
  }
  async saveVersionNoPlusOne (answerVenderDto) {
    const data = await assessmentRepository.saveVersionNoPlusOne(answerVenderDto);
    return data || [];
  }
  async findVendorAssessmentResultByConditions (params) {
    const data = await assessmentRepository.findVendorAssessmentResultByConditions(params);
    return data || [];
  }
  async generateExcel (params) {
    const data = await assessmentRepository.generateExcel(params);
    return data || [];
  }
}
module.exports = new AssessmentService();



// WEBPACK FOOTER //
// ./src/services/answerer/assessment.service.js